/** 小部件复用 Admin 登录页时的通信上下文，不经由宿主页面传递 token。 */
export interface WidgetLoginContext {
  mode: 'inline' | 'google';
  origin: string;
  requestId: string;
}

export const WIDGET_AUTH_MESSAGE_TYPE = 'GBASE_WIDGET_AUTH_RESULT';

export const getWidgetLoginContext = (url: string, currentOrigin: string): WidgetLoginContext | null => {
  try {
    const params = new URL(url).searchParams;
    const mode = params.get('widget_login');
    const origin = params.get('widget_origin');
    const requestId = params.get('widget_request_id');
    if ((mode !== 'inline' && mode !== 'google') || !origin || !requestId || !/^[a-f0-9]{32}$/.test(requestId)) {
      return null;
    }
    const target = new URL(origin);
    const current = new URL(currentOrigin);
    // 与现有登录回跳规则一致：同源或同根域；仅允许 origin，不接受任意回跳路径。
    const baseDomain = (hostname: string) => hostname.split('.').slice(-2).join('.');
    if (
      target.origin !== origin ||
      !['http:', 'https:'].includes(target.protocol) ||
      target.protocol !== current.protocol ||
      (target.hostname !== current.hostname && baseDomain(target.hostname) !== baseDomain(current.hostname)) ||
      (mode === 'google' && origin !== currentOrigin)
    ) {
      return null;
    }
    return { mode, origin, requestId };
  } catch {
    return null;
  }
};

export const withWidgetLoginContext = (url: string, context: WidgetLoginContext): string => {
  const target = new URL(url);
  target.searchParams.set('widget_login', context.mode);
  target.searchParams.set('widget_origin', context.origin);
  target.searchParams.set('widget_request_id', context.requestId);
  return target.href;
};

export const isWidgetAuthResult = (data: unknown, requestId: string): data is { token: string } => {
  if (!data || typeof data !== 'object') return false;
  const result = data as Record<string, unknown>;
  return (
    result.type === WIDGET_AUTH_MESSAGE_TYPE &&
    result.requestId === requestId &&
    typeof result.token === 'string' &&
    !!result.token
  );
};
